import React from "react";
import App from "./App";
import AgencyConfigurator from "./agency/AgencyConfigurator";

const variant = (process.env.REACT_APP_CONFIGURATOR_VARIANT || "legacy").toLowerCase();

export default function AppSelector() {
  if (variant === "b2c" || variant === "agency") {
    return <AgencyConfigurator />;
  }

  return <App />;
}
